import React from "react";
import "../../SecuritySchoolsComponents/TabCard.css";
import Link from '@mui/material/Link';

function IdentiyAccessManagement() {
  return (
    <>
    <div className="tabCard-content">
      <div className="SSA-row" id="">
        <div className="SSA-box">
                <Link to={'/SailPointIdentityIQ'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/1-SailPoint-IIQ.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>SailPoint IIQ​​</h3>
                        <p>SailPoint IdentityIQ is a blended learning program designed to provide an in-depth understanding of SailPoint IdentityIQ, focusing on IdentityIQ architecture and its key features.</p>
                        <a href="/SailPointIdentityIQ" >Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/SailPointIdentityNow'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/2-SailPoint-IDN.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>SailPoint IDN​</h3>
                        <p>SailPoint IdentityNow is an instructor-led training that covers the concepts of application onboarding and correlation, troubleshooting, debugging, and console. The course will help participants</p>
                        <a href="/SailPointIdentityNow">Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/OracleIdentityManagement​​​s'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/3-Oracle-Identity-Management.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>Oracle Identity Management​​​</h3>
                        <p>With Accenture Security’s focus on Identity & Access Management practice, it becomes important that we learn, design, and implement IAM solutions </p>
                        <a href="/OracleIdentityManagement​​​s" >Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/OracleIdentityGovernance'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/4-Oracle-Identity-Governance.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>Oracle Identity Governance​​​</h3>
                        {/* <p className="comingSoonText">Coming soon!</p> */}
                        <p>Oracle Identity Governance is a solution that provides self-service, compliance, provisioning, and password management services</p>
                        <a href="/OracleIdentityGovernance" >Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/CyberarkEPM'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/5-CyberArk-EPM.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>CyberArk EPM​​</h3>
                        {/* <p className="comingSoonText">Coming soon!</p> */}
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                        <a href="/CyberarkEPM" >Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/CyberarkPAM'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/6-CyberArk-PAM.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>CyberArk PAM​​​</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                        <a href="/CyberarkPAM" >Learn more</a>
                    </div>
                </Link>
                </div>
                <div className="SSA-box">
                <Link to={'/Forgerock'} className="calendar-link">
                    <img src="images/SecuritySchools/OracleIdentity/IdentityNew/7-ForgeRock.png" alt="SSA-img" className="SSA-img" />
                    <div className="SSA-box-content">
                        <h3>ForgeRock​​​</h3>
                        <p>ForgeRock is the digital identity and access management (IAM) software system. ​</p>
                        <a href="/Forgerock" >Learn more</a>
                    </div>
                </Link>
                </div>
            

        </div>
    </div>
    </>
  );
}

export default IdentiyAccessManagement;
